import { Component, Input } from '@angular/core';

@Component({
    selector: 'cmps-coaching-commitment-badge',
    template: ` <ng-content></ng-content>`,
    host: {
        class: 'cmps-coaching-commitment-badge',
        '[style.backgroundColor]': 'backgroundColor',
        '[style.currentColor]': 'textColor',
        '[style.color]': 'textColor',
    },
})
export class CmpsCommitmentBadgeComponent {
    @Input() backgroundColor: string;
    @Input() textColor: string;
}
